(function () {
  var config = window.freeGiftPromo;
  if (!config || !config.enabled || !config.variantId) return;

  var VARIANT_ID = Number(config.variantId);
  var THRESHOLD_CENTS = Number(config.threshold);
  var DECLINED_KEY = 'freeGiftToteDeclined';
  var syncing = false;

  function isDeclined() {
    return localStorage.getItem(DECLINED_KEY) === 'true';
  }

  function setDeclined(value) {
    if (value) {
      localStorage.setItem(DECLINED_KEY, 'true');
    } else {
      localStorage.removeItem(DECLINED_KEY);
    }
  }

  // A customer removing the tote themselves (trash icon, or dragging its
  // quantity to 0) is a deliberate opt-out and must stick — otherwise the
  // next cart refresh just adds it right back. Our own threshold-triggered
  // removeTote() below does NOT go through these listeners, so it never
  // marks the promo as declined.
  document.addEventListener('click', function (event) {
    var removeEl = event.target.closest('[data-cart-remove]');
    if (!removeEl) return;
    var removedId = removeEl.getAttribute('data-cart-remove-id');
    if (removedId && Number(removedId) === VARIANT_ID) setDeclined(true);
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-cart-quantity]');
    if (!input) return;
    var itemId = input.getAttribute('data-cart-quantity-id');
    if (itemId && Number(itemId) === VARIANT_ID && Number(input.value) <= 0) setDeclined(true);
  });

  function findToteLine(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === VARIANT_ID) return { item: cart.items[i], line: i + 1 };
    }
    return null;
  }

  // The tote's own price can swing between $0 (while a native discount is
  // granting it) and its regular price (once the discount stops qualifying),
  // so it must be excluded from the cart total before comparing to the
  // threshold — otherwise losing the discount can make the total look like
  // it still qualifies, and the tote never gets removed.
  function qualifyingTotal(cart, existing) {
    var toteContribution = existing ? existing.item.final_price * existing.item.quantity : 0;
    return cart.total_price - toteContribution;
  }

  function addTote() {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: VARIANT_ID, quantity: 1, properties: { _free_gift: 'true' } })
    });
  }

  function removeTote(line) {
    return fetch(routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: 0 })
    });
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (res) { return res.json(); });
  }

  function syncTote(cart) {
    if (syncing) return Promise.resolve(cart);

    if (cart.item_count === 0) setDeclined(false);

    var existing = findToteLine(cart);
    // Its presence — however it got there, including the customer manually
    // re-adding it from the product page — means they want it, so any prior
    // opt-out no longer applies.
    if (existing) setDeclined(false);

    var qualifies = qualifyingTotal(cart, existing) >= THRESHOLD_CENTS;

    if (qualifies && !existing && !isDeclined()) {
      syncing = true;
      return addTote()
        .then(fetchCart)
        .catch(function (err) {
          console.error('[free-gift-tote] failed to add tote', err);
          return cart;
        })
        .finally(function () { syncing = false; });
    }

    if (!qualifies && existing) {
      syncing = true;
      return removeTote(existing.line)
        .then(fetchCart)
        .catch(function (err) {
          console.error('[free-gift-tote] failed to remove tote', err);
          return cart;
        })
        .finally(function () { syncing = false; });
    }

    return Promise.resolve(cart);
  }

  // Shopify.getCart() drives most post-add-to-cart refreshes.
  var originalGetCart = Shopify.getCart;
  Shopify.getCart = function (callback) {
    originalGetCart(function (cart) {
      syncTote(cart).then(function (finalCart) {
        if (typeof callback === 'function') {
          callback(finalCart);
        } else {
          Shopify.onCartUpdate(finalCart);
        }
      });
    });
  };

  // Shopify.changeItem()/removeItem() (quantity edits, line removal on the
  // cart page/sidebar) call the shared getCartUpdate() helper directly and
  // never go through Shopify.getCart, so it needs its own wrapper.
  if (typeof window.getCartUpdate === 'function') {
    var originalGetCartUpdate = window.getCartUpdate;
    window.getCartUpdate = function (line, quantity, callback) {
      originalGetCartUpdate(line, quantity, function (cart) {
        syncTote(cart).then(function (finalCart) {
          if (typeof callback === 'function') {
            callback(finalCart);
          } else {
            Shopify.onCartUpdate(finalCart);
          }
        });
      });
    };
  }

  document.addEventListener('DOMContentLoaded', function () {
    fetchCart().then(syncTote);
  });
})();
